import React from "react";

import { NavItemData } from "./components/SideBar/SidebarNav";
import { MODULES } from "./config/modules";

import HistoryIcon from "./components/SVGIcons/HistoryIcon";
import ChatIcon from "./components/SVGIcons/ChatIcon";
import AIhubIcon from "./components/SVGIcons/AIhubIcon";
import NlgraphIcon from "./components/SVGIcons/NlgraphIcon";
import QaIcon from "./components/SVGIcons/QaIcon";
import ChatKGIcon from "./components/SVGIcons/ChatKGIcon";
import DocFinderIcon from "./components/SVGIcons/DocFinderIcon";
import ConsGuardIcon from "./components/SVGIcons/ConsGuardIcon";
import AdminDashboardIcon from "./components/SVGIcons/AdminDashboardIcon";
import OnboardingCopilotIcon from "./components/SVGIcons/OnboardingCopilot";



export const baseConfig = {
  projectLink: "/", // GitHub link in the navbar
  docsRepositoryBase: "", // base URL for the docs repository
  titleSuffix: "",
  search: true,
  header: true,
  headerText: "Logo",
  footer: true,

  logo: (
    <>
      <img
        src={process.env.PUBLIC_URL + "/logomoonjelly.png"}
        alt="logo"
        width="223"
        height="50"
      />
    </>
  ),
};

export const appNavs: NavItemData[] = [
  {
    eventKey: "AIHub",
    icon: <AIhubIcon />,
    title: "AI Hub",
    to: `/aihub`,
    moduleName: MODULES.AI_HUB,
  },
  {
    eventKey: "Chat",
    icon: <ChatIcon />,
    title: "Chat",
    to: `/chat`,
    moduleName: MODULES.CHAT,
  },
  {
    eventKey: "OnboardingCopilot",
    icon: <OnboardingCopilotIcon />,
    title: "Onboarding Copilot",
    to: `/onboard-copilot`,
    moduleName: MODULES.ONBOARDING_COPILOT,
  },
  {
    eventKey: "KGChat",
    icon: <ChatKGIcon />,
    title: "KG Chat",
    to: `/kgchat`,
    moduleName: MODULES.KG_CHAT,
  },
  {
    eventKey: "DocFinder",
    icon: <DocFinderIcon />,
    title: "DocFinder",
    to: `/docfinder`,
    moduleName: MODULES.DOC_FINDER,
  },
  {
    eventKey: "ConsGuard",
    icon: <ConsGuardIcon />,
    title: "ConsGuard",
    to: `/consguard-dashboard`,
    moduleName: MODULES.CONSISTENCY_GUARD,
    children: [
      {
        eventKey: "ListView",
        title: "List View",
        inheritQueryString: true,
        to: `/consguard`,
      },
    ],
  },

  {
    eventKey: "NL2Graph",
    icon: <NlgraphIcon />,
    title: "NL2Graph",
    moduleName: MODULES.NL2GRAPH,
    children: [
      {
        eventKey: "New Query",
        title: "New Query",
        to: `/newquery`,
      },
      {
        eventKey: "Settings",
        title: "Settings",
        to: `/users4`,
      },
    ],
  },
  {
    eventKey: "PreauditGroup",
    icon: <QaIcon />,
    title: "GenQ&A",
    to: `/qadashboard`,
    moduleName: MODULES.QNA,
    children: [
      {
        eventKey: "New Project",
        title: "New Project",
        to: `/qanewproject`,
      }
    ],
  },
  {
    eventKey: "History",
    icon: <HistoryIcon />,
    title: "History",
    to: `/history`,
    moduleName: MODULES.HISTORY,
  },
  {
    eventKey: "AdminDashboard",
    icon: <AdminDashboardIcon />,
    title: "AI Adoption",
    to: "/admin-dashboard",
    moduleName: MODULES.AI_ADOPTION,
  },
];
